<template>
  <div>
    <vx-card>
      <ListFornecedores :subjectPermission="subjectPermission" />
    </vx-card>
  </div>
</template>

<script>
import ListFornecedores from "./../../lists/ListFornecedores";

export default {
  data() {
    return {
      subjectPermission: "Fornecedor",
    };
  },
  methods: {},
  components: {
    ListFornecedores,
  },
};
</script>
